import { cn } from '@/lib/utils';
import { PoMark, type LoaderProps } from './po-mark';

/**
 * The PlanOmatic favicon mark, animated. Three SVG paths pop in with overshoot,
 * staggered, then collapse and loop. `prefers-reduced-motion` disables the
 * animation and renders the static mark.
 *
 * Source: design-bundle "Loading States" animation #04 (Assemble).
 *
 * @category Loaders
 */
export const AssembleLoader = ({
  size = 88,
  className,
  'aria-label': ariaLabel = 'Loading',
}: LoaderProps) => (
  <PoMark
    size={size}
    role="img"
    aria-label={ariaLabel}
    data-testid="assemble-loader"
    className={cn('assemble-loader', className)}
  />
);
